import React from "react";
import { Icon } from "../../../blent-component/Icon";
import { ImageFinderProps } from "./../../../types/globals.types";
import styles from "./styles.module.scss";

const imageFilenames: string[] = [
  "FY23_Bombay_Global_Advocacy_AnneBrock_MasterDiller_Profile9.jpg",
  "US_Bacardi_Cocktail_Spiced_Rum_Punch_Mobile_Banner_ES.jpg",
  "test1.jpg",
  "test2.jpg",
  "test3.jpg",
];

export const ImageGrid: React.FC<ImageFinderProps> = ({
  images,
  activeImage,
  setActiveImg,
}) => {
  if (!images?.length) return null;
  //else

  return (
    <div className={styles.imageGrid}>
      {images.map((image, i) => (
        <div
          key={i}
          className={`${styles.imageItem} ${
            activeImage?.thumbnail === image.thumbnail ? styles.active : ""
          }`}
          onClick={() => setActiveImg(image)}
        >
          <img
            src={`${process.env.REACT_APP_API_BASE_URL}${image.thumbnail}`}
            alt={`img-${i}`}
          />
          {activeImage?.thumbnail === image.thumbnail && (
            <div className={styles.activeIcon}>
              <Icon name="CheckCircle1" size={35} />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
